import { render, staticRenderFns } from "./FCDashboardStatusSelector.vue?vue&type=template&id=6fa280f4&scoped=true&"
import script from "./FCDashboardStatusSelector.vue?vue&type=script&lang=js&"
export * from "./FCDashboardStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboardStatusSelector.vue?vue&type=style&index=0&id=6fa280f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa280f4",
  null
  
)

export default component.exports